// Global API Configuration for JustERPs
export const API_BASE_URL = "https://justerps.com";
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
  return `${API_BASE_URL}/api/${cleanEndpoint}`;
};
